import { getSearchConfig, type TSearchConfigAPIResponse } from '@atlassian/search-client';
import { createResource } from 'react-resource-router/resources';

import { fg } from '@townsquare/stat-sig/gate';

const THIRTY_MINUTES = 60_000 * 30;

export const searchConfigurationResource = createResource<TSearchConfigAPIResponse>({
	getData: async (_, __) => {
		return await getSearchConfig({})
			.then(data => {
				return data;
			})
			.catch(() => {
				return {
					resources: [],
					intercomHmac: '',
					siteMetadata: [],
				};
			});
	},
	getKey: () => 'search-configuration-resource-key',
	type: 'SEARCH_CONFIGURATION',
	maxAge: fg('townsquare_react_18_loop_fixes') ? THIRTY_MINUTES : 0,
});
